import apiClient from './api.service';
import { FaqItemPublic, FaqItemAdmin, CreateFaqItemRequest, UpdateFaqItemRequest } from '../types/faq.types';

class FaqService {
  async listPublic(): Promise<FaqItemPublic[]> {
    const response = await apiClient.get<{ data: FaqItemPublic[] }>('/api/faq');
    return response.data.data;
  }

  async listAdmin(): Promise<FaqItemAdmin[]> {
    const response = await apiClient.get<{ data: FaqItemAdmin[] }>('/api/admin/faq');
    return response.data.data;
  }

  async create(payload: CreateFaqItemRequest): Promise<FaqItemAdmin> {
    const response = await apiClient.post<{ data: FaqItemAdmin }>('/api/admin/faq', payload);
    return response.data.data;
  }

  async update(id: number, payload: UpdateFaqItemRequest): Promise<FaqItemAdmin> {
    const response = await apiClient.patch<{ data: FaqItemAdmin }>(`/api/admin/faq/${id}`, payload);
    return response.data.data;
  }
}

export const faqService = new FaqService();
